var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "43",
        height: "42",
        viewBox: "0 0 43 42",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M40.3863 7.50039C40.3863 18.6066 23.9433 32.5976 7.64457 32.5976L7.06763 33.8957C7.06763 34.7611 9.37542 35.4823 10.6735 35.4823L25.3857 35.7708L27.5492 39.0882L31.0109 39.9537L36.3477 35.915C37.5016 35.915 42.5499 34.7611 42.5499 34.0399V8.65428C42.5499 7.78886 41.5402 7.21191 40.3863 7.21191H38.2228H38.5112L40.3863 7.50039Z",
          fill: "#E6E7E8",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M32.0206 12.1159C32.6579 12.1159 33.1745 11.5993 33.1745 10.962C33.1745 10.3247 32.6579 9.80811 32.0206 9.80811C31.3833 9.80811 30.8667 10.3247 30.8667 10.962C30.8667 11.5993 31.3833 12.1159 32.0206 12.1159Z",
          fill: "#FD6144",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M35.6265 12.1159C36.2638 12.1159 36.7804 11.5993 36.7804 10.962C36.7804 10.3247 36.2638 9.80811 35.6265 9.80811C34.9893 9.80811 34.4727 10.3247 34.4727 10.962C34.4727 11.5993 34.9893 12.1159 35.6265 12.1159Z",
          fill: "#FD6144",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M19.4718 28.8477H34.6167C35.1936 28.8477 35.7706 29.2804 35.7706 30.0015C35.7706 30.5785 35.3379 31.1554 34.6167 31.1554H19.4718C18.8949 31.1554 18.3179 30.7227 18.3179 30.0015C18.4622 29.4246 18.8949 28.8477 19.4718 28.8477Z",
          fill: "#FD6144",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M31.0108 24.0874H34.6167C35.1937 24.0874 35.7706 24.5201 35.7706 25.2413C35.7706 25.8182 35.3379 26.3952 34.6167 26.3952H31.0108C30.4339 26.3952 29.8569 25.9625 29.8569 25.2413C30.0012 24.5201 30.4339 24.0874 31.0108 24.0874Z",
          fill: "#FD6144",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M30.0012 41.396C28.9915 41.396 27.9819 40.9633 27.2607 40.2421L24.3759 37.3574C24.0875 37.0689 23.5105 36.7804 23.0778 36.7804H9.80804C7.64449 36.7804 5.76941 35.0496 5.76941 32.7418V27.982C5.91365 27.5493 6.34636 27.1166 6.9233 27.1166C7.50025 27.1166 8.0772 27.5493 8.0772 28.2705V32.886C8.0772 33.8957 8.94262 34.6169 9.80804 34.6169H23.0778C24.0875 34.6169 25.0971 35.0496 25.8183 35.7708L28.7031 38.6555C29.4242 39.3767 30.5781 39.3767 31.2993 38.6555L34.184 35.7708C34.9052 35.0496 35.9149 34.6169 36.9245 34.6169H38.6554C39.665 34.6169 40.3862 33.7515 40.3862 32.886V9.80816C40.3862 8.7985 39.5208 8.07732 38.6554 8.07732H31.8763C31.2993 8.07732 30.7224 7.64461 30.7224 6.92343C30.7224 6.20224 31.1551 5.76953 31.8763 5.76953H38.6554C40.8189 5.76953 42.694 7.50037 42.694 9.80816V32.886C42.694 35.0496 40.9632 36.9247 38.6554 36.9247H36.9245C36.4918 36.9247 35.9149 37.0689 35.6264 37.5016L32.7417 40.3864C32.0205 40.9633 31.0108 41.396 30.0012 41.396Z",
          fill: "#FD6144",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M12.6928 26.9723C11.6832 26.9723 10.6735 26.5396 9.95234 25.8184L7.0676 22.9336C6.77913 22.6452 6.20218 22.3567 5.76947 22.3567H4.03863C1.87508 22.3567 0 20.6259 0 18.3181V4.03863C0 1.87508 1.73084 0 4.03863 0H24.2318C26.3953 0 28.2704 1.73084 28.2704 4.03863V18.4623C28.2704 20.6259 26.5396 22.5009 24.2318 22.5009H19.6162C19.1835 22.5009 18.6065 22.6452 18.3181 23.0779L15.4333 25.9626C14.7121 26.5396 13.7025 26.9723 12.6928 26.9723ZM4.03863 2.30779C3.02897 2.30779 2.16355 3.02897 2.16355 4.03863V18.4623C2.16355 19.472 3.02897 20.1931 3.89439 20.1931H5.62523C6.63489 20.1931 7.64455 20.6259 8.36573 21.347L11.2505 24.2318C11.9717 24.953 13.1255 24.953 13.8467 24.2318L16.7315 21.347C17.4526 20.6259 18.4623 20.1931 19.472 20.1931H24.2318C25.2414 20.1931 25.9626 19.3277 25.9626 18.4623V4.03863C25.9626 3.02897 25.0972 2.30779 24.2318 2.30779H4.03863Z",
          fill: "#5021D1",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M13.7025 17.8853C10.3851 17.8853 7.50035 15.4333 6.9234 12.26C6.9234 11.6831 7.50035 10.9619 8.0773 10.9619C8.65424 10.9619 9.08695 11.3946 9.08695 11.8273C9.51966 13.9909 11.3947 15.5775 13.7025 15.5775C16.0103 15.5775 17.8854 13.9909 18.3181 11.8273C18.4623 11.2504 18.8951 10.9619 19.3278 10.9619C20.0489 10.9619 20.4817 11.5389 20.3374 12.26C19.9047 15.4333 17.1642 17.8853 13.7025 17.8853Z",
          fill: "#5021D1",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M41.5402 16.1545H31.8764C31.2994 16.1545 30.7225 15.7218 30.7225 15.0006C30.7225 14.2794 31.1552 13.8467 31.8764 13.8467H41.5402V16.1545Z",
          fill: "#FD6144",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }